'use client'

import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Pagination } from 'swiper/modules'
import { clsx } from 'clsx'
import { ListingItem } from '@/app/listings/components/Main/ListingItem'
import { Size, Color, Condition } from '@/api'
import { useCheckedItems } from '../hooks/useCheckedItems'
import 'swiper/css'
import 'swiper/css/pagination'

export const CheckedItems = () => {
  const { listings } = useCheckedItems()

  if (listings.length === 0) return null

  return (
    <div className="relative">
      <Swiper
        breakpoints={{
          768: {
            slidesPerView: 4.2,
            spaceBetween: 2,
          },
        }}
        modules={[Navigation, Pagination]}
        slidesPerView={2}
        spaceBetween={2}
        navigation={{
          prevEl: '#button_prev',
          nextEl: '#button_next',
        }}
        pagination={{
          clickable: true,
          el: '.checked-pagination',
        }}
        loop
        className="select-none lg:pb-0"
      >
        {listings.map((listing) => (
          <SwiperSlide key={listing.id} className="!h-full">
            <ListingItem
              key={listing.id}
              uuid={listing.uuid || ''}
              title={listing.product?.productMaster?.name || ''}
              listingPrice={listing.price || 0}
              originalPrice={listing.product?.productMaster?.price || undefined}
              image={listing.images?.[0]}
              images={listing.images || undefined}
              size={listing.size as Size}
              condition={listing.condition as Condition}
              color={listing.product?.color as Color}
              sex={listing.product?.productMaster?.sex}
            />
          </SwiperSlide>
        ))}
      </Swiper>
      <span
        id="button_prev"
        className={clsx(
          'hidden  w-3 h-3 md:w-6 md:h-6 cursor-pointer absolute top-[43%] -translate-y-2/4 left-[-2vw] z-10 -rotate-45 md:flex items-center justify-center bg-transparent border-t-[6px] border-l-[6px] border-[#939393]'
        )}
      ></span>
      <span
        id="button_next"
        className={clsx(
          'hidden w-3 h-3 md:w-6 md:h-6 cursor-pointer absolute top-[43%] -translate-y-2/4 right-[-2vw] z-10 rotate-45 md:flex items-center justify-center bg-transparent border-t-[6px] border-r-[6px] border-[#939393]'
        )}
      ></span>
      {/* Pagination (モバイルのみ) */}
      <div className="checked-pagination lg:hidden flex justify-center gap-3"></div>
    </div>
  )
}
